import React from 'react'
import styled, { css } from 'styled-components'
import ContainerFull from '../../../../components/ContainerFull/index'
import Icon from '../../../../components/Icon/index'
import styledContainerQuery from 'styled-container-query'
import TextSkeleton, { Line0TextSkeleton } from '../../../../components/Text/views/TextSkeleton/index'

const StyledContainerArticle = styled(ContainerFull)`
  background-color: ${(props) => props.theme.color.background};
  border: 1px solid ${(props) => props.theme.color.backgroundBorder};
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`
const List = styled.ul`
  margin: 0;
  padding: 0 1em;
  height: 1.2em;
  overflow: hidden;
  flex: 1;
  padding-left: 1em;
`
const Controls = styled.div`
  font-size: 1.8em;
  margin-bottom: -0.2em;
  display: flex;
`
const ListItem = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
`

const LogoWrapper = styled.div`
  height: 25px;
  width: 100%;
`

const StyledIcon = styled(({ disabled, ...props }) => <Icon {...props} />)`
  user-select: none;
  display: block;
  cursor: pointer;
  ${(props) =>
    props.disabled &&
    css`
      color: ${(props) => props.theme.color.textTertiary};
    `};
`

const StyledTextSecondLineSkeleton = styled(TextSkeleton)`
  flex: 1;
  display: none;
  ${Line0TextSkeleton} {
    width: 100%;
    border-width: 20px;
  }
`

const Wrapper = styledContainerQuery.aside`
  display: flex;
  align-items: center;
  padding-top: 1em;
  padding-bottom: 1em;
  &:container(max-width: 740px) {
    padding-left: ${(props) => props.theme.sizes.gapEdge};
    padding-right: ${(props) => props.theme.sizes.gapEdge};
    flex-direction: column;
    justify-content: center;
  ${ListItem}{
    justify-content: center;
    text-align: center;
  }
  ${LogoWrapper}{
    height: 35px;
  }
  ${StyledTextSecondLineSkeleton}{
    display: block;
  }
  ${List} {
    flex-basis: 100%;
    padding: 0;
    margin-top: .5em;
  }
  ${Controls}{
    margin-top: 1em;
    font-size: 2.8em;
    justify-content: space-between;
  }
  ${StyledIcon}{
    padding-left: 1em;
    padding-right: 1em;
  }
  }
  &:container(max-width: 345px){
    ${StyledIcon}{
      padding-left: 0.5em;
      padding-right: 0.5em;
    }
  }
`
const StyledTextSkeleton = styled(TextSkeleton)`
  flex: 1;
  ${Line0TextSkeleton} {
    width: 100%;
    border-width: 20px;
  }
`

const SkeletonHeadlinePaper = () => (
  <StyledContainerArticle as="section">
    <Wrapper>
      <LogoWrapper>
        <StyledTextSkeleton lastWidth="80%" />
        <StyledTextSecondLineSkeleton lastWidth="80%" />
      </LogoWrapper>
      <Controls>
        <StyledIcon icon="arrowUp" />
        <StyledIcon icon="arrowDown" />
      </Controls>
    </Wrapper>
  </StyledContainerArticle>
)

export default SkeletonHeadlinePaper
